module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }